import React from 'react';
import { EdContainer } from '../ui/ed-container';
import { AppFooter } from './app-footer';
import { AppHeader } from './app-header';

type Props = {
	no_container?: boolean;
	max_width?: 'sm' | 'md' | 'lg' | 'xl';
	onBack?: () => void;
	no_sub_reminder?: boolean;
}

export const AppLayout: React.FC<Props> = ({
	no_container,
	max_width = 'md',
	no_sub_reminder,
	onBack,
	children
}) => {

	return <>
		<AppHeader onBack={onBack} />
		{no_container ? <>
			{children}
		</> : <EdContainer max_width={max_width}>
				<>
					{children}
				</>
			</EdContainer>}
		<AppFooter />
	</>
}
